import { action, CubePresenter, FlipIntent, Logger, Presenter } from 'wdc-cube'

import { MainPresenter } from 'src/main/Main.presenter'
import { BusinessReport } from './serasa.experian.business.types'
import { PersonReport } from './serasa.experian.person.types'
import SerasaKeys from './serasa.keys'
import { SerasaPersonRow } from './serasa.pf.types'
import { DadosEmpresaRow } from './serasa.pj.types'
import SerasaScope, { HeaderScope } from './serasa.scopes'
import serasaService from './serasa.service'
import { WaitingScope } from 'src/components/waiting/waiting.scopes'

const LOG = Logger.get('SerasaPresenter')

export class SerasaPresenter extends CubePresenter<MainPresenter, SerasaScope> {
    // :: Fields

    private readonly __headerBar: Presenter<HeaderScope, SerasaPresenter>

    // :: Constructor

    public constructor(app: MainPresenter) {
        super(app, new SerasaScope())
        this.__headerBar = new Presenter(this, this.scope.header)
    }

    // :: Methods

    public override release() {
        this.app.releaseToolbar(this.__headerBar)
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new SerasaKeys(this.app, intent)

        this.app.scope.toolbar = this.__headerBar.scope

        keys.parentSlot(this.scope)

        if (initialization) {
            await this.#initialize()
        }

        keys.parentSlot(this.scope)

        return keys.allow
    }

    async #initialize() {
        LOG.debug('initialize')
        this.scope.onFind = this.handleFind.bind(this)
    }

    @action()
    private async handleFind() {
        try {
            this.scope.waiting = new WaitingScope()

            if (this.scope.cpfCnpjSelected.length !== 11 && this.scope.cpfCnpjSelected.length !== 14) {
                this.alert('error', 'CPF/CNPJ inválido', 'O documento informado é inválido. Verifique e tente novamente.')
                return
            }
            const data = await serasaService.fetchSerasaViewInfo(this.scope.cpfCnpjSelected, this.scope.typeSelected)

            this.scope.person = (data.type === 'serasa-person' ? data.data : {}) as SerasaPersonRow
            this.scope.empresa = (data.type === 'serasa-business' ? data.data : {}) as DadosEmpresaRow
            this.scope.experianPessoa = (data.type === 'experian-person' ? data.data : {}) as PersonReport
            this.scope.experianEmpresa = (data.type === 'experian-business' ? data.data : {}) as BusinessReport
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        } finally {
            this.scope.waiting = undefined
        }
    }
}

export default SerasaPresenter
